import { createFileRoute } from "@tanstack/react-router";
import DrugAlcoholEvaluationNJ from "@/pages/DrugAlcoholEvaluationNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/drug-alcohol-evaluation-nj")({
  head: () => routeHead("/drug-alcohol-evaluation-nj"),
  component: DrugAlcoholEvaluationNJ,
});
